import PropTypes from 'prop-types';

function IFBakeryInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11318)">
                <path
                    d="M5.05583 15.8204C3.7575 12.5039 3.3889 11.8394 2.46705 9.61215C1.38629 7.00156 1.77715 2.62113 5.26882 1.49509C7.99176 0.620127 10.2751 1.81576 12.4196 5.65139C14.3246 9.04699 15.6288 12.7728 16.3393 14.4432C17.0498 16.1136 20.9473 22.5651 20.1973 26.1554C19.6676 28.7081 16.6231 30.9272 13.1344 29.1977C9.98074 27.6312 9.49934 25.7561 7.7643 22.0167C6.02926 18.2772 5.05583 15.8204 5.05583 15.8204Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.08992 14.1462C7.52908 13.1363 9.08047 9.43906 13.6438 10.7892C12.1447 12.5944 7.08992 14.1462 7.08992 14.1462Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.08772 18.9577C9.52197 17.9469 11.0734 14.2496 15.6366 15.5997C14.1386 17.4001 9.08772 18.9577 9.08772 18.9577Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.7496 25.8026C12.1828 24.7967 13.7352 21.0945 18.2975 22.4496C16.8044 24.2509 11.7496 25.8026 11.7496 25.8026Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.3665 9.42125C4.79979 8.41537 6.35215 4.71318 10.9145 6.06821C9.42133 7.86951 4.3665 9.42125 4.3665 9.42125Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.1171 20.3961C14.9911 21.9402 17.3388 23.5474 18.3512 23.6853C19.0051 23.7798 23.8305 24.0201 25.5323 24.2407C27.234 24.4613 27.8249 24.2643 27.9155 23.122C28.0061 21.9796 28.4 18.1665 28.3921 17.2684C28.3842 16.3702 28.8648 16.319 29.3926 15.996C30.342 15.417 30.1017 13.3095 29.5935 12.5335C29.0854 11.7575 28.5024 10.9106 25.6859 10.4221C24.5041 10.2133 23.3224 10.0873 22.7512 10.0282C20.951 9.88638 16.8425 9.63428 16.8425 9.63428C16.681 11.5487 15.1841 15.287 15.8183 15.8385C16.1059 16.0866 15.4638 17.4456 15.448 17.8553C15.4073 18.7098 15.2967 19.5596 15.1171 20.3961V20.3961Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M28.5615 16.559C28.5615 16.559 25.5953 16.3502 21.3174 16.2557C19.3202 16.2163 19.978 20.2972 20.1356 23.6416C20.435 23.7716 24.6105 24.1655 26.1822 24.3073C27.7539 24.4491 27.8249 24.0709 27.9627 22.6095C28.1006 21.1481 28.1124 19.2927 28.5615 16.559Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.3315 19.3519C11.2094 20.9 10.5082 22.9917 11.5166 23.1335C12.1705 23.228 16.6376 23.4683 18.3511 23.685C20.0646 23.9016 20.6437 23.7086 20.7343 22.5702C20.8249 21.4318 21.2188 17.6147 21.207 16.7127C21.1952 15.8106 21.6797 15.7673 22.2115 15.4443C23.1608 14.8652 22.9205 12.7578 22.4084 11.9778C21.8963 11.1978 21.3212 10.3588 18.489 9.86641C16.8835 9.61044 15.2547 9.53118 13.632 9.63006C11.8318 9.79157 10.394 10.8118 10.2758 12.226C10.1182 14.1365 10.5712 14.3531 11.2055 14.9007C11.3407 15.0489 11.4427 15.2244 11.5045 15.4153C11.5664 15.6062 11.5866 15.8082 11.5639 16.0076C11.5127 17.2405 11.3315 19.3519 11.3315 19.3519Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11318">
                    <rect width="30" height="30" fill="white" transform="translate(0.976562 0.380859)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default IFBakeryInactive;

IFBakeryInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

IFBakeryInactive.defaultProps = {
    className: null,
    width: 28,
};
